export default "__VITE_ASSET__DYlyxuiJ__"